

















































import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Emit, Ref, Watch } from "vue-property-decorator";
import AppChatList, { Chat, Account } from "./AppChatList.vue";
import AppChatInput from "./AppChatInput.vue";
import { Stamp } from "./AppChatStampList.vue";
import InfiniteLoading from "vue-infinite-loading";

@Component({
  components: { AppChatList, AppChatInput, InfiniteLoading }
})
export default class AppChatRoom extends Vue {
  @Prop() selfEwellUserId!: number;
  @Prop() inifiniteState!: string;
  @Prop({
    default: () => {
      return [];
    }
  })
  chats!: Chat[];
  @Prop({
    default: () => {
      return [];
    }
  })
  accounts!: Account[];
  @Prop() dropChatModeFlg!: boolean;

  @Ref("AppChatRoomChatList")
  private readonly appChatRoomChatList!: HTMLDivElement;
  @Ref("InfiniteLoading")
  private readonly infiniteLoading!: InfiniteLoading;

  private savedDistanceFromBottom: number | null = null;
  private isDestroyed = false;

  @Emit()
  private sendMessage(message: string) {
    return message;
  }

  @Emit()
  private sendStamp(stamp: Stamp) {
    return stamp;
  }

  @Emit()
  private sendImage(file: File) {
    return file;
  }

  @Emit()
  private reachedTop(id?: string) {
    return id;
  }

  @Emit("drop:chat")
  private dropChat(id: string) {
    return id;
  }

  @Emit("dropChatMode:off")
  private dropChatModeOff() {
    return false;
  }

  @Watch("chats")
  private chatsDidChange() {
    // チャットが更新された時、画面最下部にいた場合、受け取ったチャットを表示するために最下部へスクロール
    if (this.isReachedBottom()) {
      this.$nextTick(() => {
        this.scrollToBottom();
      });
    }
  }

  @Watch("inifiniteState")
  private changeInifiniteState() {
    switch (this.inifiniteState) {
      case "loaded":
        this.infiniteLoading.stateChanger.loaded();
        break;
      case "complete":
        this.infiniteLoading.stateChanger.complete();
        break;
      case "reset":
        this.infiniteLoading.stateChanger.reset();
        break;
      case "error":
        this.infiniteLoading.stateChanger.error();
        break;
      default:
        // do nothing
        break;
    }
  }

  mounted() {
    this.scrollToBottom();
  }

  beforeDestroy() {
    this.isDestroyed = true;
    this.savedDistanceFromBottom = null;
  }

  scrollToBottom() {
    this.appChatRoomChatList.scrollTo(0, this.appChatRoomChatList.scrollHeight);
  }

  isReachedBottom() {
    return (
      this.appChatRoomChatList.scrollHeight -
        (this.appChatRoomChatList.scrollTop +
          this.appChatRoomChatList.clientHeight) <=
      0
    );
  }

  /** 過去チャット prepend 直前に呼ぶ（DOM成長前の状態を記録） */
  captureScrollAnchor() {
    const el = this.appChatRoomChatList;
    if (!el) return;
    this.savedDistanceFromBottom = el.scrollHeight - el.scrollTop;
  }

  /** 過去チャット prepend 直後に呼ぶ（DOM成長・ライブラリrestoreの後に絶対値で上書き＝冪等） */
  restoreScrollAnchor() {
    if (this.savedDistanceFromBottom === null) return;
    const distance = this.savedDistanceFromBottom;
    this.savedDistanceFromBottom = null;
    this.$nextTick(() => {
      requestAnimationFrame(() => {
        if (this.isDestroyed) return;
        const el = this.appChatRoomChatList;
        if (!el) return;
        el.scrollTop = el.scrollHeight - distance;
      });
    });
  }

  private infiniteHandler() {
    if (!this.chats.length) {
      this.reachedTop();
      return;
    }

    this.reachedTop(this.chats[0].id);
  }
}
